// removed by extract-text-webpack-plugin
module.exports = {"container":"_17vflzccKQXyGWCVx-rerH","inner":"_8IaSAtOiKKvNZhoTR7st9","header":"_3aW7Tt-8dAxWpM4V-FAJd_ UiOtkwjAwJvCk7RAufbT2","review-item-container":"_2WCoBJF_9oEAzXGPt3s2kZ","reviews-wrapper":"_3mQXo_WbKwwivpYpDoqpio","reviews-card-wrapper":"_20draVvdQwdnpaCvjnWTr9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/FeaturedReviews.scss
// module id = 1168
// module chunks = 47